/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./OrgBankInfo.css";
// import {simpleFetch} from '../../restWrapper';
import PropTypes from "prop-types";

class OrgBankInfo extends Component {
  constructor(props) {
    super(props);
    if (!this.props.location.state) {
      this.props.history.push({ pathname: "/OrgSettings", page: 4 });
    }
    this.state = this.props.location.state;
    this.state = {
      ...this.state,
      loading: false,
      errMsg: "",
    };
    this.backBtn = this.backBtn.bind(this);
  }
  /*
  deleteBtn(){
    this.setState({
      loading:true
    });
    simpleFetch('/organizations/banks/'+this.state.id, 'DELETE')
      .then((res) => {
        this.setState({
          loading:false
        });
        if(res.status ===204){
          this.props.history.push({ pathname: '/orgSettings',
            page: 4
          });
        }else {
          this.setState({
            errMsg:'Error'
          })
        }
      });
  }*/

  backBtn() {
    this.props.history.push({ pathname: "/OrgSettings", page: 4 });
  }

  render() {
    const languageObj = this.props.languageObj;
    var acObject = [];
    let items = this.state;

    Object.keys(items).forEach(function (i) {
      let itemName = "";
      if (i === "bank_name" || i === "last4" || i === "routing_number") {
        itemName = languageObj.info[i];
      } else {
        itemName = "";
      }

      if (itemName) {
        acObject.push(
          <div key={"key" + i + items["id"]}>
            <p />
            <strong>{itemName}</strong>
            <br />
            {items[i]}
            <p />
          </div>,
        );
      }
    });

    if (this.state.loading) {
      return (
        <div className="orgBankAdd-emptyPage">
          <div className="orgBankAdd-center">
            <div className="orgBankAdd-btm-load"></div>
          </div>
        </div>
      );
    }
    return (
      <div className="OrgBankInfo-view">
        <div className="OrgBankInfo-prompt">
          <div className="OrgBankInfo-header">
            <div className="OrgBankInfo-back" onClick={this.backBtn}>
              <div className="OrgBankInfo-backBtn"></div>
              <div className="OrgBankInfo-backText">{languageObj.backText}</div>
            </div>
          </div>

          <div className="OrgBankInfo-container">
            <div className="OrgBankInfo-heading">{languageObj.heading}</div>

            <div className="OrgBankInfo-info">{acObject}</div>
          </div>
        </div>
      </div>
    );
  }
}

OrgBankInfo.propTypes = {
  languageObj: PropTypes.object,
};

export default OrgBankInfo;
